import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Znamka } from '../model/znamka';
import { AisCommonModule } from "../../../../ais-common/src/lib/ais-common.module";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-detail-atributov-predmetu',
    templateUrl: './detail-atributov-predmetu.component.html',
    styleUrl: './detail-atributov-predmetu.component.css',
    standalone: false
})
export class DetailAtributovPredmetuComponent  implements OnInit{

  predmet: Znamka;

  constructor(
    public dialogRef: MatDialogRef<DetailAtributovPredmetuComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {predmet: Znamka},
    private translation: TranslateService
  ) {
    this.predmet = data.predmet;
  }



  ngOnInit(): void {
  }

  getPopisSemester() {
    let result = '';
    if (this.predmet.kodSemester === 'Z') {
      result = this.translation.instant('Zimný');
    } else if (this.predmet.kodSemester === 'L') {
      result = this.translation.instant('Letný');
    }

    result += ' ' + this.translation.instant('semester');

    return result;
  }

}
